<template>
  <div class="main-content" id="panel">
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-2 col-6">
              <h2>Set Capital</h2>
            </div>
            <div class="col-lg-10 col-md-12 col-10 text-right bid">
              <div class="input-group d-inline-flex justify-content-end">
              <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                <i @click="searchBranch()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                <input v-on:keyup.enter="searchBranch" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search" aria-label="Search">
                <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                </form>
                <div>
                  <button v-if="tradingStatus"  @click="killTradingAllBranches('ENABLE')" type="button" class="btn btn-success mr-3"><i class="fa fa-toggle-on"></i> ENABLE TRADING</button>
                  <button v-if="!tradingStatus"  @click="killTradingAllBranches('DISABLE')" type="button" class="btn btn-danger mr-3"><i class="fa fa-power-off"></i> DISABLE TRADING</button>
                </div>
              <!-- <button  @click="killOperations()" type="button" class="btn btn-danger mr-3"><i class="fa fa-power-off"></i> KILL SWITCH</button> -->

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
    <div class="container-fluid mt--6 ">
      <div class="row">
        <div class="col-xl-12">
          <div class="card vh-75" id="scroll">
            <div class="table-responsive">
              <div v-if="loading" class="loader">
                <img src="@/assets/img/loader.svg" alt="" />
              </div>
              <table
                class="table align-items-center table-flush table-hover bidtbl"
              >
                <thead class="thead-light psticky">
                  <tr>
                    <th
                      scope="col"
                      class="sort text-center"
                      v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'firstName'
                          ? 'sort-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'firstName'
                          ? 'sort-desc'
                          : '',
                      ]"
                      @click="sort('firstName')"
                    >
                      Branch
                    </th>
                    <th scope="col" class="text-center">Cusip <br>  Max Qty </th>
                    <!-- <th scope="col" class="text-left">DEPLOYED</th> -->

                    <th
                      scope="col"
                      class="sort"
                      v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'autobidderCapital'
                          ? 'sort-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'autobidderCapital'
                          ? 'sort-desc'
                          : '',
                      ]"
                      @click="sort('autobidderCapital')"
                    >
                    Capital Invested/Bought Today <br>IMS CAPITAL/AT RISK
                    </th>
                    <th scope="col" class="text-left">STATE/CONC/DOLLAR AMOUNT<br>Bought Today/IMS CAPITAL/AT RISK </th>
                    <th scope="col" class="text-left">RATING/CONC/DOLLAR AMOUNT <br> Bought Today/IMS CAPITAL/AT RISK </th>
                    <th scope="col" class="text-center">BRANCH LIMIT <br>ALERT </th>
                    <th scope="col" class="text-center">BRANCH PAR <br>MAX/AT RISK </th>
                    <th scope="col" class="text-center">COMPLIANCE <br> STATUS</th>
                    <th scope="col" class="text-center">TRADING <br> STATUS</th>
                    <th scope="col" class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody class="list no-cursor">
                  <tr v-if="branches.length == 0 && !loading">
                    <td><p class="nodata">No data available</p></td>
                  </tr>
                  <tr v-for="branch in branches" :key="branch.branchName">
                    <td class="text-center"
                    >
                      <span class="text-info" style="text-transform: uppercase;font-weight: 500;">{{ branch.branchName }}</span>
                    </td>
                    <td class="text-center" >
                     <span  v-if="branch.cusipConcList.length > 0">
                      {{ formatNumber(branch.cusipConcList[0].concentrationValue) }} 
                    </span> 
                    </td>
                    <!-- <td class="input-d text-left">
                      <span class="text-warning" v-if="branch.maxCapitalConcList.length > 0">
                      {{ branch.maxCapitalConcList[0].allocatedCapital  | currency }} 
                    </span> 
                    </td> -->
                    <td class="input-d text-left">
                      <span class="text-warning" v-if="branch.maxCapitalConcList.length > 0">
                      {{ branch.maxCapitalConcList[0].concentrationValueDolAmt  | currency }} / {{branch.maxCapitalConcList[0].capitalInvestedDolAmt  | currency}}  <br> {{ branch.maxCapitalConcList[0].invOfferDolAmt  | currency}} / {{branch.maxCapitalConcList[0].capitalAtRisk  | currency }}
                    </span> 
                    </td>
                    
                    <td class="text-left" >
                      <div class="listAcc" v-for="(state,index) in branch.stateConcList" :key="index" v-show="index < 3">
                        <span class="text-primary border-bottom py-2">
                          {{ state.concentration }} / {{ state.concentrationValue }}% / {{ state.concentrationValueDolAmt  | currency }} <br>
                         {{ state.capitalInvestedDolAmt  | currency }} /  {{ state.invOfferDolAmt  | currency}} /  {{ state.capitalAtRisk  | currency}}
                        </span>
                      </div>
                      <span  @click="toggleViewConcentrationModal(branch,'STATE')" class="dropdown-item moreAcc" v-show="branch.stateConcList.length > 3">
                          ({{branch.stateConcList.length - 3 }} More)
                      </span>
                    </td>
                    <td class="text-left" >
                      <div class="listAcc" v-for="(rating,index) in branch.creditRatingConcList" :key="index" v-show="index < 3">
                        <span class="text-success border-bottom py-2">{{ rating.concentrationList[0] }} <span style="font-size: 15px; color: rgb(0, 135, 212);">&rarr;</span> {{ rating.concentrationList[rating.concentrationList.length - 1] }} / {{ rating.concentrationValue }}% / {{ rating.concentrationValueDolAmt  | currency }} <br> {{ rating.capitalInvestedDolAmt  | currency }} /  {{ rating.invOfferDolAmt  | currency}} /  {{ rating.capitalAtRisk  | currency}}</span>
                      </div>
                      <span  @click="toggleViewConcentrationModal(branch,'RATING')" class="dropdown-item moreAcc" v-show="branch.creditRatingConcList.length > 3">
                          ({{branch.creditRatingConcList.length - 3 }} More)
                      </span>
                    </td>
                    <td class="text-center">
                      <span v-if="branch.branchLimit"> {{ branch.branchLimit  | currency  }} </span> 
                    </td>
                    <td class="text-center">
                      <span v-if="branch.branchPaxMax"> {{ formatNumber(branch.branchPaxMax)  }} / {{ formatNumber(branch.branchPaxAtRisk)  }} </span> 
                    </td>
                    <td class="text-center">
                       <span v-if="branch.tradeComplianceActive" class="text-success">ENABLED</span>
                       <span v-if="!branch.tradeComplianceActive" class="text-danger">DISABLED</span>
                    </td>
                    <td class="text-center">
                       <span v-if="!branch.tradeKillActive" class="text-success">ENABLED</span>
                       <span v-if="branch.tradeKillActive" class="text-danger">DISABLED</span>
                    </td>
                    <td class="text-center">
                      <div style="display: grid;">
                      <button
                        type="button"
                        @click="toggleConcentrationModal(branch)"
                        class="btn btn-secondary  btn-sm my-1 autowidth"
                      >
                        <i class="fas fa-check"></i> SET CONCENTRATION
                      </button>
                      <button
                        type="button"
                        @click="toggleTraderConcetrationModal(branch)"
                        class="btn btn-secondary  btn-sm my-1 autowidth"
                      >
                        <i class="fa fa-users"></i> TRADER CONCENTRATION
                      </button>
                      <button
                        v-if="branch.tradeKillActive"
                        data-toggle="tooltip" data-placement="left"  data-original-title="Enable"
                        type="button"
                        @click="killOperations('ENABLE',branch.branchOrgToken)"
                        class="btn btn-success  btn-sm my-1 autowidth"
                      >
                        <i class="fa fa-unlock"></i> ENABLE TRADING
                      </button>
                      <button
                      v-if="!branch.tradeKillActive"
                        data-toggle="tooltip" data-placement="left"  data-original-title="Disable"
                        type="button"
                        @click="killOperations('DISABLE',branch.branchOrgToken)"
                        class="btn btn-danger  btn-sm my-1 autowidth"
                      >
                        <i class="fa fa-lock"></i> DISABLE TRADING
                      </button>
                      
                      <button
                        v-if="!branch.tradeComplianceActive"
                        data-toggle="tooltip" data-placement="left"  data-original-title="Enable concentration"
                        type="button"
                        @click="enableOrdisableCompliance(branch,'ENABLE')"
                        class="btn btn-secondary  btn-sm my-1 autowidth"
                      >
                        <i class="fa fa-toggle-on"></i> ENABLE COMPLIANCE
                      </button>
                      <button
                        v-if="branch.tradeComplianceActive"
                          data-toggle="tooltip" data-placement="left"  data-original-title="Disable concentration"
                          type="button"
                          @click="enableOrdisableCompliance(branch,'DISABLE')"
                          class="btn btn-secondary  btn-sm my-1 autowidth"
                        >
                          <i class="fa fa-toggle-off"></i> DISABLE COMPLIANCE
                      </button>
                    </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
   <Concentration 
      v-if="concentrationModalOpen"
      v-bind:branchData="selectedBranch"
      v-bind:selectedOrgToken="selectedOrgToken"
      @close="toggleConcentrationModal()"/>
    <TraderConcentration  
      v-if="traderConcentrationModalOpen"
      v-bind:selectedBranch="selectedBranch"
      @close="toggleTraderConcetrationModal()"
    />
    <ViewConcentration
      v-if="viewConcentrationModalOpen"
      v-bind:traderData="selectedTrader"
      v-bind:type="selectedConcentrationType"
      @close="toggleViewConcentrationModal()"/>    
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import Concentration from "./BrockerDealerSetConcentrationModal"
import TraderConcentration from "./BranchTraderWiseConcSettingModal"
import ViewConcentration from "../ConcentrationViewDataModal"

export default {
  name: "branches",
  components: {
    Concentration,
    TraderConcentration,
    ViewConcentration
  },
  data() {
    return {
      branches: [],
      config: config,
      loading: false,
      currentPage: 1,
      perPage: 10,
      searchValue: "",
      totalRows: 0,
      sortColumn: "firstName",
      sortOrder: "ASC",
      tenantName: null,
      bidSettings: {},
      selectedBranch: null,
      modalOpen: false,
      traderData: {},
      accountList: [],
      branchList : [],
      selectedOrgToken : null,
      isBrokerDealerRiskManager : false,
      concentrationModalOpen : false,
      traderConcentrationModalOpen : false,
      viewConcentrationModalOpen : false,
      selectedConcentrationType : "",
      tradingStatus : false

    };
  },
  created() {},
  methods: {
    toggleViewConcentrationModal(data,type){
      this.selectedTrader = {...data}
      this.selectedConcentrationType = type
      this.viewConcentrationModalOpen = !this.viewConcentrationModalOpen;
    },
    toggleTraderConcetrationModal(branch){
      if(branch){
        this.selectedBranch = branch;
      }
      this.traderConcentrationModalOpen = !this.traderConcentrationModalOpen;
    },
    toggleConcentrationModal(data){
      this.selectedBranch = {...data}
      this.concentrationModalOpen = !this.concentrationModalOpen;
      if(!this.concentrationModalOpen){
        this.getBranchList()
      }
    },
    searchBranch() {
      this.getBranchList();
    },
    clearSearch() {
      this.searchValue = "";
      this.getBranchList();
    },
    sort(column) {
      this.sortColumn = column;
      this.sortOrder =
        this.sortOrder == "ASC"
          ? (this.sortOrder = "DESC")
          : (this.sortOrder = "ASC");
      this.getBranchList();
    },
    getBranchList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
       
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
            "/compliance/list-branches?page=" +
            currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&brokerOrgToken="+
            authService.getOrgToken(),
          auth
        )
        .then((result) => {
          this.branches = result.data.data;
          this.tradingStatus =  result.data.tradingStatus
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    killOperations(status,orgToken){
        var message = "Are you sure you want to "+(status.toLowerCase())+" all traders?";
        this.$confirm(message,"Confirm","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
             const auth = {
                
            };
            this.loading = true;
            let isKill = status == 'ENABLE' ?  false : true;
            this.$http
                .post(
                config.baseUrlAutoBidder +
                    "/autobidder/kill-switch?orgToken="+orgToken+"&isKill="+isKill,{},
                    auth
                )
                .then(() => {
                    this.loading = false;
                    this.getBranchList();
                    this.$alert("Under process.","","success");
                })
        })
    },
    enableOrdisableCompliance(branch,status){
        const message = `Are you sure you want to ${status.toLowerCase()} concentration for this branch?`;
        this.$confirm(message,"Confirm","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          let params = `?orgToken=${branch.branchOrgToken}&isComplianceCheck=${status == 'ENABLE' ?  "true" : "false"}`  
          this.loading = true;
          const auth = {
              
          };
          this.$http
              .post(
              config.baseUrlAutoBidder +
                  "/compliance/branch-compliance"+params,{},
                  auth
              )
              .then(() => {
                  this.loading = false;
                  this.$alert("Successfully updated ","","success")
                  this.getBranchList()
              })
              .catch(e => {
                  console.log(e);
              });
        })
    },
    killTradingAllBranches(status){
        var message = "Are you sure you want to "+(status.toLowerCase())+" all traders?";
        this.$confirm(message,"Confirm","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
             const auth = {
                
            };
            this.loading = true;
            let isKill = status == 'ENABLE' ?  false : true;
            this.$http
                .post(
                config.baseUrlAutoBidder +
                    "/autobidder/broker-dealer-kill-switch?orgToken="+authService.getOrgToken()+"&isKill="+isKill,{},
                    auth
                )
                .then(() => {
                    this.loading = false;
                    this.$alert("Successfully updated.","","success");
                    this.getBranchList()
                })
        })
    },
  },
  mounted() {
        this.$cognitoAuth.getUserGroup((err, role) => {
          if (err) {
            console.log("accessToken is not found", err);
          } else {
            var roleArray = role.map(item => {
              return  item.split("-")[1];
            })
            this.tenantName = role[0].split("-")[0];
            this.isBrokerDealerRiskManager =  roleArray.includes("BrokerDealerRiskManager") ? this.isBrokerDealerRiskManager = true : this.isBrokerDealerRiskManager = false;
            this.selectedOrgToken = authService.getOrgToken();
            this.getBranchList();
          }
        });
      }
    };
</script>
<style scoped>
.listAcc{
  display: grid;
  grid-gap:5px;
}
.btn {
  margin: 0;
  text-align: left;
}
</style>